import { render, staticRenderFns } from "./JobboardUsers.vue?vue&type=template&id=3bb5b960"
import script from "./JobboardUsers.vue?vue&type=script&lang=js"
export * from "./JobboardUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports